var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "purchase-box" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.editableTabsValue,
            callback: function($$v) {
              _vm.editableTabsValue = $$v
            },
            expression: "editableTabsValue"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "代采组", name: "group" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "代采员", name: "member" } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.editableTabsValue == "group"
        ? _c("div", [_c("get-list")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.editableTabsValue == "member"
        ? _c("div", [_c("member")], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70b0df14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b0df14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchasegroup/Purchase.vue
// module id = null
// module chunks = 